import React, { useEffect, useRef } from 'react'
import styles from './Hero.module.scss'

import logo from '../../../assets/logo.svg'
import illus1 from '../../../assets/illus1.png'
import illus2 from '../../../assets/illus2.png'
import illus3 from '../../../assets/illus3.png'

import Cursor from '../../Cursor/Cursor'
import RoundText from './RoundText/RoundText';
import Button from './Button/Button';
import Heading from './Heading/Heading'
import Parallax from 'parallax-js'

const Hero = () => {

    const scene1 = useRef(null)
    const scene2 = useRef(null)
    const scene3 = useRef(null)

    useEffect(() => {
        const parallaxInstance1 = new Parallax(scene1.current, {
            relativeInput: true
        });
        parallaxInstance1.friction(0.2, 0.2);

        const parallaxInstance2 = new Parallax(scene2.current, {
            relativeInput: true
        });
        parallaxInstance2.friction(0.2, 0.2);

        const parallaxInstance3 = new Parallax(scene3.current, {
            relativeInput: true
        });
        parallaxInstance3.friction(0.2, 0.2);

    }, [])


    return (
        <div style={{ height: window.innerHeight }} className={styles.landing} >
            <Cursor color='#000' />

            <div className={styles.header}>
                <div className={styles.logo}>
                    <img src={logo} alt='logo' />
                </div>
                
                <div className={styles.nameHeader}>
                    <h1>Muhammad Shaheryar Haider</h1>
                </div>

                <div className={styles.socialLinks}>
                    <a href="https://github.com/Shaheryar123" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12Z" fill="currentColor"/>
                        </svg>
                    </a>
                    <a href="https://linkedin.com/in/shaheryar-haider-dev" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="currentColor"/>
                        </svg>
                    </a>
                    <a href="/Shaheryar_Haider.pdf" download="Muhammad_Shaheryar_Haider_Resume.pdf" className={styles.socialLink} title="Download Resume">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                            <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                            <path d="M12 18l-3-3m0 0l3-3m-3 3h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                        </svg>
                    </a>
                </div>
            </div>

            <div className={styles.containerWrapper} >
                <div className={styles.container} >

                    <div className={styles.cont1} >
                        <Heading />
                        <h5>I'm a passionate developer who loves crafting beautiful, functional digital experiences that solve real-world problems.</h5>
                        <Button />
                    </div>

                    <div>
                        <div className={styles.roundText} >
                            <RoundText color='#000' />
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={styles.leftCont} ref={scene1} data-relative-input="true" data-clip-relative-input="true" id="scene" >
                                <div data-depth="0.5" ><img src={illus1} alt='illus1' /></div>
                            </div>
                            <div className={styles.leftCont} ref={scene2} data-relative-input="true" data-clip-relative-input="true" id="scene" >
                                <div data-depth="0.5" ><img src={illus2} alt='illus2' /></div>
                            </div>
                            <div className={styles.leftCont} ref={scene3} data-relative-input="true" data-clip-relative-input="true" id="scene" >
                                <div data-depth="0.5" ><img src={illus3} alt='illus3' /></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Hero